/**
 * Display names from Google/email signup. Hides 1–2 letter stubs such as "Ac".
 */

/**
 * Real given name, or empty when the stored name looks like initials.
 *
 * @param {{ first_name?: string, last_name?: string } | null | undefined} user
 * @returns {string}
 */
export const usableDisplayName = (user) => {
  const first = String(user?.first_name || '').trim();
  const last = String(user?.last_name || '').trim();
  if (last) {
    return [first, last].filter(Boolean).join(' ');
  }
  if (first.length >= 3) {
    return first;
  }
  return '';
};

/**
 * Label for greetings and the nav identity (name, else email local part).
 *
 * @param {{ first_name?: string, last_name?: string, email?: string } | null | undefined} user
 * @returns {string}
 */
export const identityLabel = (user) => {
  const name = usableDisplayName(user);
  if (name) {
    return name;
  }
  const local = String(user?.email || '').split('@')[0].trim();
  return local;
};
